import utils from '@/common/util/utils'
import { DEVICE_TYPE } from '@/common/resources/const'
import { removeNullishProperty } from '@/common/util/common'

export const getUserExternalId = () => {
  const uno = utils.cookies.getUno()
  const profileId = utils.cookies.getProfileId()
  if (uno === 'none' || profileId === 'none') {
    return 'none'
  }
  return `${uno}_${profileId}`
}

export const convertAmountToNumber = (amount) => {
  const result = parseInt(`${amount}`.replace(/,/g, ''))
  return isNaN(result) ? undefined : result
}

export const getPurchaseProperties = (origin) => {
  const result = removeNullishProperty({
    product_id: origin.productId,
    price: convertAmountToNumber(origin.price),
    currency: 'KRW',
    device_type: DEVICE_TYPE.get('mobile')
  })
  if (origin.amount) {
    result.pg_amount = convertAmountToNumber(origin.amount)
  }
  return result
}

/**
 * 이용권 정보 중 브레이즈에 전달할 파라미터를 추출하고 정규화합니다.
 * @param {object} origin { productid: string, product_name: string, amount: string}
 * @returns {object} { productId: string, productName: string, price: number}
 */
export const normalizePurchaseParams = (origin) => {
  const {
    productid: productId,
    amount
  } = origin

  return {
    productId,
    // 결제 완료시 payletter에서 실제 이용권 금액정보가 amount라는 파라미터로 넘어오기 때문에 price로 이름 변경
    price: convertAmountToNumber(amount)
  }
}
